import React from "react";
import { Link } from "react-router-dom";
export const PAoverUpgrade = ({
  awards = true,
  cards = true,
  project = {},
}) => (
  <div className="pa_prj_line pa_prj_line--last">
    <div className={awards ? "pa_prj_cols_upgrade" : ''}>
      {awards && (
        <div className="pa_prj_section">
          <div className="pa_prj_label pa_prj_label--1">
            <div>Progress</div>
          </div>
          <div className="pa_prj_progress">
            <div className="pa_prj_progress_li">
              <div className="pa_prj_progress_badge">
                <div className="pa_prj_progress_badge_dummy">
                  <div>done</div>
                </div>
              </div>
              <div className="pa_prj_progress_badge_name">
                <div>First integration</div>
              </div>
            </div>
            <div className="pa_prj_progress_li">
              <div className="pa_prj_progress_badge">
                <div className="pa_prj_progress_badge_dummy">
                  <div className="pa_prj_progress_badge_icon w-embed">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={48}
                      height={48}
                      viewBox="0 0 48 48"
                    >
                      <g
                        fill="none"
                        fillRule="evenodd"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path d="M29 24a5 5 0 0 1-5 5" />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M12 47v-9.498a5 5 0 0 1 3.291-4.699L21 31.091v-3.114A4.976 4.976 0 0 1 19 24v-2.785a5.145 5.145 0 0 1 4.509-5.192A5.001 5.001 0 0 1 29 21v3a4.976 4.976 0 0 1-2 3.977v3.114l5.73 1.745A5 5 0 0 1 36 37.527V47"
                        />
                        <path strokeLinecap="round" d="M17 41v6m14-6v6m-7-5" />
                        <circle cx={4} cy={21} r={3} strokeLinecap="round" />
                        <circle cx={34} cy={4} r={3} strokeLinecap="round" />
                        <circle cx={14} cy={4} r={3} strokeLinecap="round" />
                        <path
                          strokeLinecap="round"
                          d="M7.208 21H16m16 0h9M5.787 18.604l4.67-9.087m17.626 4.65l4.375-7.459m9.709 11.75l-5-9.416m-17.542 5.083L15.75 6.542M28 4H17M5.787 23.437l4.67 8.088m31.71-7.942l-5 8.417"
                        />
                        <circle cx={44} cy={21} r={3} strokeLinecap="round" />
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
              <div className="pa_prj_progress_badge_name">
                <div>First 100 gamers</div>
              </div>
            </div>
            <div className="pa_prj_progress_li">
              <div className="pa_prj_progress_badge">
                <div className="pa_prj_progress_badge_dummy pa_prj_progress_badge_dummy--inact">
                  <div className="pa_prj_progress_badge_icon w-embed">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={48}
                      height={48}
                      viewBox="0 0 43 42"
                    >
                      <path
                        fill="currentColor"
                        fillRule="nonzero"
                        d="M28.375 34.655a1 1 0 0 1 .374.416l1.751 3.628 1.751-3.628a1 1 0 0 1 .374-.416l3.477-2.155-3.477-2.155a1 1 0 0 1-.374-.416L30.5 26.301l-1.751 3.628a1 1 0 0 1-.374.416L24.898 32.5l3.477 2.155zM16 23.874A4.002 4.002 0 0 1 13 20a1 1 0 0 1 2 0 2 2 0 1 0 2-2 4 4 0 0 1-1-7.874V9a1 1 0 0 1 2 0v1.126c1.725.444 3 2.01 3 3.874a1 1 0 0 1-2 0 2 2 0 1 0-2 2 4 4 0 0 1 1 7.874V25a1 1 0 0 1-2 0v-1.126zm6.473 9.476a1 1 0 0 1 0-1.7l4.601-2.852 2.525-5.233a1 1 0 0 1 1.802 0l2.525 5.233 4.6 2.852a1 1 0 0 1 0 1.7l-4.6 2.852-2.525 5.233a1 1 0 0 1-1.802 0l-2.525-5.233-4.6-2.852zm8.015-15.491a1 1 0 0 1 0-1.718l3.304-1.971 1.814-3.618a1 1 0 0 1 1.788 0l1.814 3.618 3.304 1.971a1 1 0 0 1 0 1.718l-3.304 1.971-1.814 3.618a1 1 0 0 1-1.788 0l-1.814-3.618-3.304-1.971zm4.58.404a1 1 0 0 1 .381.41L36.5 20.77l1.05-2.096a1 1 0 0 1 .382-.41L40.048 17l-2.116-1.263a1 1 0 0 1-.381-.41L36.5 13.23l-1.05 2.096a1 1 0 0 1-.382.41L32.952 17l2.116 1.263zm-15.465 13.53a1 1 0 1 1 .327 1.974C11.107 35.227 2.637 29.692.5 21.063c-2.14-8.632 2.78-17.441 11.28-20.212 8.5-2.77 17.714 1.427 21.144 9.634a1 1 0 0 1-1.846.771C28.05 4.012 19.91.304 12.4 2.752 4.893 5.2.554 12.97 2.44 20.582c1.887 7.614 9.367 12.502 17.163 11.212zm6.247-8.767a1 1 0 0 1 1.682 1.082c-3.266 5.074-9.555 7.186-15.16 5.086-5.598-2.097-9.024-7.84-8.268-13.843.757-6.006 5.5-10.69 11.442-11.287 5.944-.598 11.502 3.053 13.403 8.795a1 1 0 0 1-1.898.629C25.443 8.63 20.753 5.55 15.746 6.054c-5.01.503-9.017 4.46-9.658 9.547-.64 5.089 2.26 9.95 6.986 11.72 4.72 1.77 10.018-.01 12.776-4.295z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="pa_prj_progress_badge_name">
                <div>First $10K</div>
              </div>
            </div>
            <div className="pa_prj_progress_li">
              <div className="pa_prj_progress_badge">
                <div className="pa_prj_progress_badge_dummy pa_prj_progress_badge_dummy--inact">
                  <div className="pa_prj_progress_badge_icon w-embed">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={48}
                      height={48}
                      viewBox="0 0 48 48"
                    >
                      <g
                        fill="none"
                        fillRule="evenodd"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path d="M29 29V8l-4-7h-2l-4 7v21zm-10-6h-3l-3 3v7h2l4-4zm10 0h3l3 3v7h-2l-4-4zm-9 13v2m0 2v2m8-6v2m0 2v2m-4-2v2m6-8v2m0 2v2m-12-6v2m0 2v2" />
                        <path
                          strokeLinecap="round"
                          d="M7.778 42.222a3.111 3.111 0 0 1 6.222 0M7 36a3.111 3.111 0 0 1 3.111 3.111"
                        />
                        <path d="M24 36v2m0-6v2m-4-2v2m8-2v2m-6-9h4m-2-7v-2m0-2v-2m0-2V8M1 43v2l2 2h42l2-2v-2z" />
                        <path
                          strokeLinecap="round"
                          d="M44 43V17a2 2 0 0 0-2-2H32M4 43V17a2 2 0 0 1 2-2h10m24.222 27.222a3.111 3.111 0 0 0-6.222 0M41 36a3.111 3.111 0 0 0-3.111 3.111"
                        />
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
              <div className="pa_prj_progress_badge_name">
                <div>Launch</div>
              </div>
            </div>
            <div className="pa_prj_progress_li">
              <div className="pa_prj_progress_badge">
                <div className="pa_prj_progress_badge_dummy pa_prj_progress_badge_dummy--inact">
                  <div className="pa_prj_progress_badge_icon w-embed">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width={48}
                      height={48}
                      viewBox="0 0 48 48"
                    >
                      <g fill="none" fillRule="evenodd">
                        <path
                          stroke="currentColor"
                          strokeWidth={2}
                          d="M13.412 15L9 22.059v1.765l15 14.117 15-14.117v-1.765L34.588 15zM39 22.941H9m9.706 0l5.294 15"
                        />
                        <path
                          stroke="currentColor"
                          strokeWidth={2}
                          d="M24 37.941l5.294-15L24 15m-10.588 0l5.294 7.941m10.588 0L34.588 15m-10.533 0l-5.35 7.941"
                        />
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeWidth={2}
                          d="M1 24h3m40 0h3M4.081 35.5L6.68 34m34.64-20l2.599-1.5M12.5 43.919L14 41.32M34 6.68l1.5-2.599M24 47v-3m0-40V1m11.5 42.919L34 41.32M14 6.68l-1.5-2.6M43.919 35.5L41.32 34M6.68 14l-2.6-1.5"
                        />
                        <circle
                          cx="9.858"
                          cy="9.858"
                          r={1}
                          fill="currentColor"
                          fillRule="nonzero"
                          transform="rotate(-45 9.858 9.858)"
                        />
                        <circle
                          cx="38.142"
                          cy="38.142"
                          r={1}
                          fill="currentColor"
                          fillRule="nonzero"
                          transform="rotate(-45 38.142 38.142)"
                        />
                        <circle
                          cx="4.681"
                          cy="18.824"
                          r={1}
                          fill="currentColor"
                          fillRule="nonzero"
                          transform="rotate(-75 4.681 18.824)"
                        />
                        <circle
                          cx="43.319"
                          cy="29.176"
                          r={1}
                          fill="currentColor"
                          fillRule="nonzero"
                          transform="rotate(-75 43.319 29.176)"
                        />
                        <circle
                          cx="4.681"
                          cy="29.176"
                          r={1}
                          fill="currentColor"
                          fillRule="nonzero"
                          transform="rotate(-15 4.681 29.176)"
                        />
                        <circle
                          cx="43.319"
                          cy="18.824"
                          r={1}
                          fill="currentColor"
                          fillRule="nonzero"
                          transform="rotate(-15 43.319 18.824)"
                        />
                        <circle
                          cx="9.858"
                          cy="38.142"
                          r={1}
                          fill="currentColor"
                          fillRule="nonzero"
                          transform="rotate(-45 9.858 38.142)"
                        />
                        <circle
                          cx="38.142"
                          cy="9.858"
                          r={1}
                          fill="currentColor"
                          fillRule="nonzero"
                          transform="rotate(-45 38.142 9.858)"
                        />
                        <circle
                          cx="18.824"
                          cy="43.319"
                          r={1}
                          fill="currentColor"
                          fillRule="nonzero"
                          transform="rotate(-75 18.824 43.319)"
                        />
                        <circle
                          cx="29.176"
                          cy="4.681"
                          r={1}
                          fill="currentColor"
                          fillRule="nonzero"
                          transform="rotate(-75 29.176 4.681)"
                        />
                        <circle
                          cx="29.178"
                          cy="43.319"
                          r={1}
                          fill="currentColor"
                          fillRule="nonzero"
                          transform="rotate(-15 29.178 43.319)"
                        />
                        <circle
                          cx="18.824"
                          cy="4.681"
                          r={1}
                          fill="currentColor"
                          fillRule="nonzero"
                          transform="rotate(-15 18.824 4.681)"
                        />
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
              <div className="pa_prj_progress_badge_name">
                <div>First $50K</div>
              </div>
            </div>
          </div>
        </div>
      )}

      {cards && project["cards"] === 1 && (
        <div className="pa_prj_section">
          <div className="pa_prj_label0">
            <div className="pa_prj_label pa_prj_label--1">
              <div>Ways to Upgrade</div>
            </div>
            <div>
              <div className="pa_prj_label pa_prj_label--1">
                <div>See all solutions</div>
              </div>
            </div>
          </div>
          <div className="pa_prj_cards0">
            <div className="pa_prj_solutions_ul pa_prj_solutions_ul--featured">
              <div className="xbe_card0 xbe_card0--h">
                <div className="xbe_card xbe_card--hor">
                  <div className="xbe_card_pic0">
                    <div className="xbe_card_pic xbe_card_pic--hor">
                      <div className="xbe_card_pic_abs" />
                      <div className="xbe_card_pic_grad" />
                    </div>
                  </div>
                  <div className="xbe_card_flex">
                    <div className="xbe_card_content">
                      <div className="xbe_card_line">
                        <div className="xbe_card_badge0">
                          <div>Open new territories</div>
                        </div>
                      </div>
                      <div className="xbe_card_line">
                        <div className="xbe_card_title">
                          <div>
                            Build direct relationships with players to grow your
                            business
                          </div>
                        </div>
                      </div>
                      <div className="xbe_card_line">
                        <div className="xbe_card_desc">
                          <div>
                            Create a loyal community, communicate with your
                            players, and keep control of your cross-platform
                            gamers’ data with our comprehensive distribution
                            tools to represent your game.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="xbe_card0 xbe_card0--h">
                <div className="xbe_card xbe_card--h">
                  <div className="xbe_card_flex">
                    <div className="xbe_card_content">
                      <div className="xbe_card_line">
                        <div className="xbe_card_badge0">
                          <div>Open new territories</div>
                        </div>
                      </div>
                      <div className="xbe_card_line">
                        <div className="xbe_card_title">
                          <div>
                            Distribute games more easily with flexible
                            simplicity
                          </div>
                        </div>
                      </div>
                      <div className="xbe_card_line">
                        <div className="xbe_card_desc">
                          <div className="text-block-27">
                            Deliver game keys for every platform where your
                            title is available and give you more control over
                            where and how you sell.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="pa_prj_cards_more0">
              <Link to="/start" className="pa_prj_cards_more">
                <div className="pa_prj_icon">
                  <div>more_horiz</div>
                </div>
              </Link>
            </div>
          </div>
        </div>
      )}

      {cards && project["cards"] === 2 && (
        <div className="pa_prj_section">
          <div className="pa_prj_label0">
            <div className="pa_prj_label pa_prj_label--1">
              <div>Ways to Upgrade</div>
            </div>
            <div>
              <div className="pa_prj_label pa_prj_label--1">
                <div>See all solutions</div>
              </div>
            </div>
          </div>
          <div className="pa_prj_cards0">
            <div className="pa_prj_solutions_ul">
              <div className="xbe_card0 xbe_card0--h">
                <div className="xbe_card xbe_card--h">
                  <div className="xbe_card_pic0 xbe_card_pic0--h">
                    <div className="xbe_card_pic xbe_card_pic0--h">
                      <div className="xbe_card_pic_abs xbe_card_pic_abs--twitch" />
                      <div className="xbe_card_pic_grad" />
                    </div>
                  </div>
                  <div className="xbe_card_flex">
                    <div className="xbe_card_content">
                      <div className="xbe_card_line">
                        <div className="xbe_card_badge0">
                          <div>Open new territories</div>
                        </div>
                      </div>
                      <div className="xbe_card_line">
                        <div className="xbe_card_title">
                          <div>
                            Build direct relationships with players to grow your
                            business
                          </div>
                        </div>
                      </div>
                      <div className="xbe_card_line hidden">
                        <div className="xbe_card_desc">
                          <div>
                            Create a loyal community, communicate with your
                            players, and keep control of your cross-platform
                            gamers’ data with our comprehensive distribution
                            tools to represent your game.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="xbe_card0 xbe_card0--h">
                <div className="xbe_card xbe_card--h">
                  <div className="xbe_card_pic0">
                    <div className="xbe_card_pic xbe_card_pic0--h">
                      <div className="xbe_card_pic_abs xbe_card_pic_abs--2" />
                      <div className="xbe_card_pic_grad" />
                    </div>
                  </div>
                  <div className="xbe_card_flex">
                    <div className="xbe_card_content">
                      <div className="xbe_card_line">
                        <div className="xbe_card_badge0">
                          <div>Open new territories</div>
                        </div>
                      </div>
                      <div className="xbe_card_line">
                        <div className="xbe_card_title">
                          <div>
                            Distribute games more easily with flexible
                            simplicity
                          </div>
                        </div>
                      </div>
                      <div className="xbe_card_line hidden">
                        <div className="xbe_card_desc">
                          <div className="text-block-27">
                            Deliver game keys for every platform where your
                            title is available and give you more control over
                            where and how you sell.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="xbe_card0 xbe_card0--h">
                <div className="xbe_card xbe_card--h">
                  <div className="xbe_card_pic0">
                    <div className="xbe_card_pic xbe_card_pic0--h">
                      <div className="xbe_card_pic_abs xbe_card_pic_abs--3" />
                      <div className="xbe_card_pic_grad" />
                    </div>
                  </div>
                  <div className="xbe_card_flex">
                    <div className="xbe_card_content">
                      <div className="xbe_card_line">
                        <div className="xbe_card_badge0">
                          <div>Open new territories</div>
                        </div>
                      </div>
                      <div className="xbe_card_line">
                        <div className="xbe_card_title">
                          <div>Turn your players into monthly subscribers</div>
                        </div>
                      </div>
                      <div className="xbe_card_line hidden">
                        <div className="xbe_card_desc">
                          <div className="text-block-27">
                            Drive frictionless adoption with 700+ recurring and
                            nonrecurring payment methods like credit cards,
                            debit cards, digital wallets, and offline payments.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="pa_prj_cards_more0">
                <Link to='/start' className="pa_prj_cards_more">
                  <div className="pa_prj_icon">
                    <div>more_horiz</div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  </div>
);
